import { render, staticRenderFns } from "./VerOrdemServico.vue?vue&type=template&id=15f90bfa&scoped=true&"
import script from "./VerOrdemServico.vue?vue&type=script&lang=js&"
export * from "./VerOrdemServico.vue?vue&type=script&lang=js&"
import style0 from "./VerOrdemServico.vue?vue&type=style&index=0&id=15f90bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f90bfa",
  null
  
)

export default component.exports